import { Controller } from "@hotwired/stimulus"

// Prefills the unit_price field and adjusts quantity step based on the selected warehouse item.
export default class extends Controller {
    static targets = ["itemSelect", "priceField", "quantityField", "unitLabel", "nameField", "newItemForm", "newItemName", "newItemUnit", "newItemPrice", "newItemQuantity", "newItemError", "createItemButton"]

    limitQuantity(event) {
        const maximum = parseFloat(event.currentTarget.max)
        const quantity = parseFloat(event.currentTarget.value)
        if (Number.isFinite(maximum) && Number.isFinite(quantity) && quantity > maximum) {
            event.currentTarget.value = maximum
        }
    }

    prefill() {
        const selected = this.itemSelectTarget.selectedOptions[0]
        if (!selected || !selected.value) return

        const price = selected.dataset.price
        if (price && this.hasPriceFieldTarget) {
            this.priceFieldTarget.value = price
        }

        if (this.hasNameFieldTarget) {
            this.nameFieldTarget.value = selected.dataset.name || ""
        }

        if (this.hasQuantityFieldTarget) {
            const wholeUnit = selected.dataset.wholeUnit === "true"
            this.quantityFieldTarget.step = wholeUnit ? "1" : "0.001"
            this.quantityFieldTarget.min = wholeUnit ? "1" : "0.001"
            this.quantityFieldTarget.max = selected.dataset.available
        }

        if (this.hasUnitLabelTarget) {
            this.unitLabelTarget.textContent = selected.dataset.unitLabel || ""
        }
    }

    showNewItemForm() {
        this.newItemFormTarget.classList.remove("d-none")
        this.newItemNameTarget.focus()
    }

    hideNewItemForm() {
        this.newItemFormTarget.classList.add("d-none")
        this.newItemErrorTarget.classList.add("d-none")
        this.newItemErrorTarget.textContent = ""
    }

    async createWarehouseItem() {
        if (!this.newItemNameTarget.value.trim() || !this.newItemUnitTarget.value) {
            this.showNewItemError(this.pickerMessages().missingFields)
            return
        }

        this.createItemButtonTarget.disabled = true
        const formData = new FormData()
        formData.append("warehouse_item[name]", this.newItemNameTarget.value.trim())
        formData.append("warehouse_item[unit]", this.newItemUnitTarget.value)
        formData.append("warehouse_item[sales_price]", this.newItemPriceTarget.value || "0")
        formData.append("warehouse_item[quantity_on_hand]", this.newItemQuantityTarget.value || "0")

        try {
            const response = await fetch("/warehouse_items.json", {
                method: "POST",
                headers: { "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content },
                body: formData
            })
            const data = await response.json()
            if (!response.ok) {
                this.showNewItemError(data.errors?.join(", ") || this.pickerMessages().createError)
                return
            }

            const option = new Option(data.name, data.id, true, true)
            option.dataset.name = data.name
            option.dataset.price = data.sales_price
            option.dataset.available = data.quantity_available
            option.dataset.wholeUnit = data.whole_unit
            option.dataset.unitLabel = data.unit_label
            if (this.hasItemSelectTarget) {
                this.itemSelectTarget.add(option)
                this.prefill()
            } else {
                this.element.dispatchEvent(new CustomEvent("warehouse-item:created", { bubbles: true, detail: data }))
            }
            this.hideNewItemForm()
        } catch (_error) {
            this.showNewItemError(this.pickerMessages().createError)
        } finally {
            this.createItemButtonTarget.disabled = false
        }
    }

    showNewItemError(message) {
        this.newItemErrorTarget.textContent = message
        this.newItemErrorTarget.classList.remove("d-none")
    }

    pickerMessages() {
        const picker = this.element.querySelector("[data-warehouse-item-picker]")
        return { missingFields: picker.dataset.missingFieldsMessage, createError: picker.dataset.createErrorMessage }
    }
}
